module.exports = __webpack_public_path__ + "img/thumbnail-3@2x.fa32450d.jpg";